import { Swiper } from './swiper.min.js';
 if(!customElements.get("product-table-grid")){
   class ProductTableGrid extends HTMLElement {
     constructor() {
       super();
       this.swiperWrapper = this.querySelector("product-table-grid [data-products-slider]");
       this.accordion = this.closest("custom-accordion");
       this.selectors = {
        slider: "product-table-grid [data-products-slider]",
        prevButton: "product-table-grid .btn-slide-prev",
        nextButton: "product-table-grid .btn-slide-next",
        staticContents: "[data-static-content]",
        contents: "[data-content]",
        labels: "[data-label]",
       }
       this.staticContentElements = [...this.querySelectorAll(this.selectors.staticContents)];
       this.contentElements = [...this.querySelectorAll(this.selectors.contents)];
       this.labelElements = [...this.querySelectorAll(this.selectors.labels)];
       this.hiddenElements = [...this.querySelectorAll("[data-initial-hidden]")];
       this.hiddenHeights = {};
     }
     connectedCallback() {
       this.initSwiper();
       this.initializeIndexing();
       this.calculateStaticContentMargins();
       this.calculateMargins();
       this.setupHidden();
     }
     initializeIndexing(){
      this.contentByIndex = [];
      this.contentElements.forEach(content => {
        const index = content.dataset.index;
        if (!this.contentByIndex[index]) {
          this.contentByIndex[index] = [];
        }
        this.contentByIndex[index].push(content);
      });
     }
     setupHidden(){
      const hiddenMaxHeight = Object.values(this.hiddenHeights).reduce((acc, height) => acc + height, 0);
      const accordionRow = this.accordion.querySelector(".accordion-more");
      this.accordion.setAttribute("data-initial-height", accordionRow.offsetHeight - hiddenMaxHeight);
      this.accordion.setAttribute("data-full-height", accordionRow.offsetHeight);
     }
     calculateStaticContentMargins(){
      let hiddenTypes = {};
      const hiddenMarginOffset = 15;
      const staticContentGroups = {};
      this.staticContentElements.forEach(element => {
        const contentType = element.dataset.staticContent;
        if (!staticContentGroups[contentType]) {
          staticContentGroups[contentType] = [];
        }
        if(element.dataset.initialHidden) hiddenTypes[contentType] = true;
        staticContentGroups[contentType].push(element);
      });

      Object.keys(staticContentGroups).forEach(contentType => {
        const elements = staticContentGroups[contentType];
        const maxHeight = elements.reduce((max, element) => {
          const offset = element.dataset.staticOffset ? parseFloat(element.dataset.staticOffset) : 0;
          const offsetMobile = element.dataset.staticOffsetMobile ? parseFloat(element.dataset.staticOffsetMobile) : 0;
          const currentHeight = window.innerWidth > 989 ? element.scrollHeight + offset : element.scrollHeight + offsetMobile;
          return Math.max(max, currentHeight);
        }, 0);

        elements.forEach(element => {
          element.style.height = `${maxHeight}px`;
        });
        if(hiddenTypes[contentType])this.hiddenHeights[contentType] = maxHeight + hiddenMarginOffset;
      });
     }
     calculateMargins(){
      this.labelElements.forEach(label => {
        const index = label.dataset.index;
        const contents = this.contentByIndex[index];
        const maxHeight = contents.reduce((max, content) => {
          const computedStyle = window.getComputedStyle(content);
          const paddingTop = parseFloat(computedStyle.paddingTop);
          const marginBottom = parseFloat(computedStyle.marginBottom);
          const currentHeight = content.clientHeight + marginBottom - paddingTop;
          return Math.max(max, currentHeight);
        }, 0);
        label.style.marginBottom = `${maxHeight}px`;
      });
     }
     initSwiper() {
       this.swiperObj = new Swiper(
        this.selectors.slider,
         {
           spaceBetween: 15,
           lazy: true,
           slidesPerView: 1.5,
           resistance: true,
           observer: true,
           observeParents: true,
           watchSlidesVisibility: true,
           watchSlidesProgress: true,
           watchOverflow: true,
           keyboard: {
             enabled: true,
             onlyInViewport: true,
           },
           autoplay: false,
           mousewheel: {
            forceToAxis: true,
          },
           navigation: {
            nextEl: this.selectors.nextButton,
            prevEl: this.selectors.prevButton,
           },
           breakpoints: {
            1310:{
                slidesPerView: 5.5,
            },
            900: {
              slidesPerView: 3
            },
            500:
            {
                slidesPerView: 2.5
            }
          }
         }
       );
     }
   }
   customElements.define("product-table-grid", ProductTableGrid);
 }